import Papa from 'papaparse';
import fileDownload from 'react-file-download';

import { CategoryItem } from '~/services/ExperiencesService';

import { CSV_COMMENT_PREFIX } from './parseExperienceCategoryFile';

export function generateCategoryTemplate(categories: CategoryItem[]): void {
  const uploadRows = [
    { 'DEAL ID': 'offer-id-1', 'CATEGORY TAGS': '"Beaches & Islands","Outdoor Activities"', ACTION: 'add' },
    { 'DEAL ID': 'offer-id-2', 'CATEGORY TAGS': '"City Tours"', ACTION: 'remove' },
  ];

  // CSV has no concept of multiple sheets, so the valid-category reference (previously its own
  // "Categories" sheet) is emitted as comment lines below the template rows. The parser strips
  // any line starting with CSV_COMMENT_PREFIX on re-upload, so these never count as upload rows
  // and the template rows keep their original 1-based line numbers for error reporting.
  const referenceLines = [
    `${CSV_COMMENT_PREFIX} Valid categories — copy the exact CATEGORY LABEL into the CATEGORY TAGS column`,
    `${CSV_COMMENT_PREFIX} CATEGORY ID | CATEGORY LABEL`,
    ...(categories ?? []).map((c) => `${CSV_COMMENT_PREFIX} ${c.id} | ${c.label ?? c.value}`),
  ];

  const csv = [Papa.unparse(uploadRows), ...referenceLines].join('\r\n');

  fileDownload(csv, 'bulk-category-update-template.csv');
}
